export default __webpack_public_path__ + "static/media/rmr_live_logo_v2.43931712.png";